import { useCallback } from 'react';
import {
    Button, Table,
} from 'reactstrap';
import { v7 as uuid } from 'uuid';
import { isEmpty } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { NumericInput, SmallButton } from '../common/forms/FormElements';
import { TipAlert } from '../common/TipAlert';
import { Modal } from '../common/Modal';

export class PaySource {
    id = uuid();
    usStateId = 0;
    payRate = '';
}

export const USCountyGroupStatePayRateGrid = ({
    usStates,
    payRates,
    onPayRatesChange,
}) => {
    const handleSubmit = useCallback((newPaySource) => {
        const updatedPaySources = [...payRates, newPaySource];
        onPayRatesChange(updatedPaySources);
    }, [payRates, onPayRatesChange]);

    const handleRemovePaySourceButtonClick = useCallback((id) => {
        const updated = payRates.filter((rule) => rule.id !== id);

        onPayRatesChange(updated);
    }, [payRates, onPayRatesChange]);

    const handleAddPayRate = useCallback(() => {
        Modal.show({
            title: 'Add State Pay Rate',
            onSubmit: (values) => handleSubmit(values),
            body: () => (
                <>
                    <TipAlert
                        label="Any employees with this local set as their home local will be paid out at this rate for any work performed in the selected state."
                    />

                    <NumericInput
                        id="payRate"
                        name="payRate"
                        label="Pay Rate"
                        required
                        step={0.01}
                        min={0}
                        error="A pay rate is required."
                    />

                    <ValidatedSelect
                        id="usStateId"
                        name="usStateId"
                        required
                        options={usStates}
                        error="A state selection is required."
                        label="State"
                    />
                </>
            ),
        });
    }, [handleSubmit, usStates]);

    return (
        <div>
            <div className="d-flex justify-content-end mb-1">
                <SmallButton
                    type="button"
                    onClick={handleAddPayRate}
                >
                    <FontAwesomeIcon
                        icon={faPlusCircle}
                        size="md"
                        className="mr-2"
                    />
                    Add Pay Rate
                </SmallButton>
            </div>

            <Table
                className="table table-sm"
                bordered
                responsive
            >
                <thead>
                    <tr>
                        <th>
                            Pay
                        </th>
                        <th>
                            If employee works in
                        </th>
                        <th className="text-center">
                            <FontAwesomeIcon icon={faTrash} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {isEmpty(payRates) ? (
                        <tr>
                            <td
                                colSpan={5}
                                className="text-center"
                            >
                                No state pay rates found
                            </td>
                        </tr>
                    ) : (
                        payRates.map((rate) => {
                            const stateLabel = usStates.find((state) => state.value === rate.usStateId)?.label;

                            return (
                                <tr key={rate.id}>
                                    <td>
                                        {rate.payRate}
                                    </td>

                                    <td>
                                        {stateLabel}
                                    </td>
                                    <td
                                        className="text-center"
                                        style={{ width: '30px' }}
                                    >
                                        <Button
                                            type="button"
                                            color="outline-primary"
                                            onClick={() => handleRemovePaySourceButtonClick(rate.id)}
                                            size="sm"
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Button>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
        </div>
    );
};
